module.exports = __webpack_public_path__ + "static/media/head_circumference.62cbcc03.svg";